import Vue from 'vue';


Vue.directive('numericOnly', {
    bind(el) {
      el.addEventListener('keyup', (e) => {
        let regex = /^[0-9]*$/
        if (!regex.test(e.target.value)) {
          e.target.value = e.target.value.replace(/\D/g, '')
        }
      })
    }
  }) 


  Vue.directive('uppercase',
  {
      inserted: function (el, _, vnode) {
          el.addEventListener('input', async function (e) {
              e.target.value = e.target.value.toUpperCase()
              vnode.componentInstance.$emit('input', e.target.value.toUpperCase())
          })
      }
  })
  